export default __webpack_public_path__ + "static/media/logos.58be0823.svg";